import {TokenCredentials} from '../login/tokencredentials';

export class BinType {
    credentials: TokenCredentials;

    id : number;
	userid : number;
    
    name : string;
	shortname : string;
	height : number;
	width : number;
	length : number;
	weight : number;
	
	relativeSize : number;

    created : Date;
    updated : Date;
}


// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/location/bintype.ts